/* Klaviyo Back in Stock - BIS API */
if (!customElements.get('bis-modal')) {
  customElements.define(
    'bis-modal',
    class BisModal extends HTMLElement {
      constructor() {
        super();

        this._selectors = {
          overlay: '.bis-modal__overlay',
          container: '.bis-modal__container',
          close: '.bis-modal__close',
          productTitle: '[js-bis-product-title]',
          form: '[js-bis-form]',
          submit: '[js-bis-submit]',
          success: '[js-bis-success]',
          error: '[js-bis-error]',
          variantSelectWrapper: '[js-bis-select-wrapper]',
          variantSelect: '[js-bis-select]',
          emailField: '[js-bis-email-field]',
          klaviyoBisTrigger: "[js-klaviyo-bis-trigger]"
        };

        this.currentVariantId = '';
      }

      connectedCallback() {
        if (!this.moved) {
          this.moved = true;
          document.body.appendChild(this);
        }

        this.overlay = this.querySelector(this._selectors.overlay);
        this.form = this.querySelector(this._selectors.form);
        this.bisSubmit = this.querySelector(this._selectors.submit);
        this.bisSuccess = this.querySelector(this._selectors.success);
        this.bisError = this.querySelector(this._selectors.error);
        this.variantSelectWrapper = this.querySelector(this._selectors.variantSelectWrapper);
        this.variantSelect = this.querySelector(this._selectors.variantSelect);

        const closeBtn = this.querySelector(this._selectors.close);
        if (closeBtn) closeBtn.addEventListener("click", this._close);
        if (this.overlay) this.overlay.addEventListener("click", this._close);
        this.addEventListener("keyup", (evt) => evt.code === "Escape" && this._close());
        if (this.form) this.form.addEventListener("submit", this._handleBisFormSubmit.bind(this));
      }

      /* Klaviyo BIS */

      _openBisModal(trigger) {
        this.triggerElement = trigger;
        this._resetBisModal();
        this._updateBisModal(trigger);
        this.classList.add("animate", "active");
        document.body.classList.add("overflow-hidden");

        this.addEventListener(
          "transitionend",
          () => {
            const container = this.querySelector(this._selectors.container);
            const focusEl = this.querySelector("input[type=\"email\"]") || container;
            if (typeof trapFocus === "function" && container) {
              trapFocus(container, focusEl);
            }
          },
          { once: true }
        );
      }

      _close = () => {
        this.classList.remove("active");
        if (typeof removeTrapFocus === "function" && this.triggerElement) {
          removeTrapFocus(this.triggerElement);
        }
        this.triggerElement = null;
        document.body.classList.remove("overflow-hidden");
      }

      _updateBisModal(trigger) {
        const productInfo = trigger.closest("product-info");
        const sectionId = this.dataset.sectionId;
        this.currentVariantId = "";

        if (productInfo) {
          const variantInput = productInfo.querySelector("input.product-variant-id[name=\"id\"]");
          if (variantInput && variantInput.value) {
            this.currentVariantId = variantInput.value;
          }
        }

        this._updateBisTitle(trigger);
        this._insertBisSelect(sectionId);
      }

      _updateBisTitle(trigger) {
        const productTitleElement = this.querySelector(this._selectors.productTitle);
        const productTitle = trigger.closest("product-info")?.querySelector("h1, .product__title h2, .product__title h1");
        if (!productTitleElement || !productTitle) return;
        productTitleElement.textContent = productTitle.textContent;
      }

      _insertBisSelect(sectionId) {
        const variantsJson = document.getElementById("BisUnavailableVariants-" + sectionId);
        const variants = variantsJson ? JSON.parse(variantsJson.textContent) : [];

        if (!this.variantSelect || !this.variantSelectWrapper) return;

        this.variantSelect.innerHTML = "";
        variants.forEach((v) => {
          const opt = document.createElement("option");
          opt.value = v.id;
          opt.textContent = v.title;
          opt.selected = String(v.id) === String(this.currentVariantId);
          this.variantSelect.appendChild(opt);
        });

        this.variantSelectWrapper.style.display = variants.length > 1 ? "" : "none";
      }

      _resetBisModal() {
        if (this.bisSubmit) this.bisSubmit.classList.remove("hidden");
        if (this.bisSuccess) this.bisSuccess.classList.add("hidden");
        if (this.bisError) this.bisError.classList.add("hidden");
      }

      _handleBisFormSubmit = (evt) => {
        evt.preventDefault();

        const formData = new FormData(this.form);
        const email = formData.get("email");
        const variant = formData.get("variant") || this.variantSelect?.value;

        if (!email || !variant) return;

        const companyId = this.dataset.klaviyoCompanyId || "N2dgMU";
        const submitId = "$shopify:::$default:::" + variant;
        const url = "https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=" + companyId;

        const payload = {
          "data": {
            "type": "back-in-stock-subscription",
            "attributes": {
              "profile": {
                "data": {
                  "type": "profile",
                  "attributes": {
                    "email": email
                  }
                }
              },
              "channels": ["EMAIL"]
            },
            "relationships": {
              "variant": {
                "data": {
                  "type": "catalog-variant",
                  "id": submitId
                }
              }
            }
          }
        };

        var requestOptions = {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "revision": "2024-06-15"
          },
          body: JSON.stringify(payload)
        };

        fetch(url, requestOptions)
          .then((result) => {
            if (result.ok) {
              this.bisSubmit.classList.add("hidden");
              this.bisSuccess.classList.remove("hidden");
            } else {
              this.bisError.classList.remove("hidden");
            }
          })
          .catch((error) => {
            console.log("error", error);
            this.bisError.classList.remove("hidden");
          });
      }
    }
  );
}

document.addEventListener("click", (evt) => {
  const trigger = evt.target.closest("[js-klaviyo-bis-trigger]");
  if (!trigger) return;
  evt.preventDefault();
  evt.stopImmediatePropagation();
  const sectionId = trigger.dataset.sectionId;
  const modal = document.getElementById("BisModal-" + sectionId);
  if (modal && typeof modal._openBisModal === "function") {
    modal._openBisModal(trigger);
  }
});
